export default {
  'error.auth.login': 'Neplatné přihlasovací údaje.',
  'error.pass.download.failed': 'Stažení karty se nepovedlo.',

  'confirmation.title': 'Upozornění',
  'confirmation.button.yes': 'Potvrdit',
  'confirmation.button.no': 'Zrušit',

  'pass.publish.confirmation': 'Změny budou publikovány a všem uživatelům bude zaslána notifikace.',
  'pass.edit.success': 'Změny byly uložené',
  'pass.publish.success': 'Změny byly publikovány',
  'pass.download.invalid': 'Neznáma karta.',

  'value.contact-type.label.PHONE': 'Telefon',
  'value.contact-type.label.EMAIL': 'E-mail',
  'value.contact-type.label.WEB': 'Web'
}

export const datePickerMessages = {
  search: 'Hledat',
  notfound: 'Nic se nenašlo',
  categories: {
    search: 'Výsledek hledání',
    recent: 'Nejčastěji používané',
    people: 'Smileys & lídé',
    nature: 'Zvířata & príroda',
    foods: 'Jídlo & pití',
    activity: 'Activity',
    places: 'Cestování & místa',
    objects: 'Objekty',
    symbols: 'Symboly',
    flags: 'Vlajky',
    custom: 'Vlastní'
  }
}
